import { GridSortItem } from '@rossum/ui/x-data-grid-pro';

export const encodeSortModel = (sortColumn: GridSortItem) =>
  `${sortColumn.sort === 'desc' ? '-' : ''}${sortColumn.field}`;

export const decodeSortModel = (ordering: string): GridSortItem[] =>
  ordering.startsWith('-')
    ? [{ field: ordering.slice(1), sort: 'desc' as const }]
    : [{ field: ordering, sort: 'asc' as const }];
